import React from 'react';
import { Tab } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { tabMenus } from '@/utils/panels';

const TabPanes = ({
  activeIndex,
  attached,
  className,
  entity,
  indexes,
  onRender,
  onTabChange,
  pointing,
  secondary,
  sections,
  tabs,
}) => {
  const intl = useIntl();

  return (
    <Tab
      activeIndex={activeIndex}
      className={clsx(className, 'aridhia-tabs-panes', 'scrollable-tab')}
      menu={{ attached, secondary, pointing }}
      onTabChange={onTabChange}
      panes={tabMenus(entity, indexes, tabs, sections, onRender, intl)}
    />
  );
};

export default TabPanes;
